import {
  ambientesSchema,
  atelieSchema,
  contatoSchema,
  depoimentoSchema,
  heroSchema,
  processoSchema,
  showroomSchema,
  type Ambientes,
  type Atelie,
  type Contato,
  type Depoimento,
  type Hero,
  type Processo,
  type Showroom,
} from '@plane/shared';

import { apiRequest } from '@/services/http-client';

export function fetchAmbientes(): Promise<Ambientes> {
  return apiRequest('/api/v1/site-content/ambientes', ambientesSchema);
}

export function fetchAtelie(): Promise<Atelie> {
  return apiRequest('/api/v1/site-content/atelie', atelieSchema);
}

export function fetchContato(): Promise<Contato> {
  return apiRequest('/api/v1/site-content/contato', contatoSchema);
}

export function fetchDepoimento(): Promise<Depoimento> {
  return apiRequest('/api/v1/site-content/depoimento', depoimentoSchema);
}

export function fetchHero(): Promise<Hero> {
  return apiRequest('/api/v1/site-content/hero', heroSchema);
}

export function fetchShowroom(): Promise<Showroom> {
  return apiRequest('/api/v1/site-content/showroom', showroomSchema);
}

export function fetchProcesso(): Promise<Processo> {
  return apiRequest('/api/v1/site-content/processo', processoSchema);
}
